import classNames from 'classnames/bind';

import styles from './EnvironmentBanner.module.scss';

const c = classNames.bind(styles);

const mode = import.meta.env.MODE;

/**
 * Banner showing the current environment
 */
export function EnvironmentBanner() {
  if (import.meta.env.PROD) {
    return null;
  }

  return <div className={c('banner', mode)}>{mode}</div>;
}
